export default "__VITE_ASSET__496ef776__"